module.exports = __webpack_public_path__ + "static/media/flag-kn.dc88507f.webp";